import React from 'react'
import ProfileHeader from './ProfileHeader'
import "./style.css";
import Steps from './Steps/Index';
import Base from '../../Components/Layout/Base';

const PortfolioProfile = () => {
  return (
   <Base>
        <ProfileHeader />
        <Steps />
   </Base>
  )
}

export default PortfolioProfile